<template>
  <div class="exam-result">
    <div class="exam-title">
      <h1 class="title" v-if="title">{{title}}</h1>
      <h2><span class="score">{{score}}</span>分</h2>
    </div>
    <div class="table-wrap">
      <div class="result-table">
        <div class="table-head">
          <div>#</div>
          <div>单词</div>
          <div>解释</div>
          <div>类型</div>
          <div>我的</div>
        </div>
        <div class="table-body">
          <div class="item" v-for="(result, index) in results" :key="index">
            <div>{{index + 1}}</div>
            <div class="text">
              <div class="text-wrap">
                <van-speaker class="normal primary" :src="result.ref.audio" />
                <span>&nbsp;{{result.ref.text}}</span>
              </div>
            </div>
            <el-tooltip
              effect="light"
              transition=""
              :disabled="result.ref.explain.length <= 18"
              :content="result.ref.explain"
              :open-delay="400"
              placement="right-start">
              <div>
                <span>{{result.ref.explain}}</span>
              </div>
            </el-tooltip>
            <div>
              <template v-if="result.ref.code === 'CHXZ'">词汇选择</template>
              <template v-else>单词拼写</template>
            </div>
            <div>
              <template v-if="result.ref.code === 'CHXZ'">
                <i class="el-icon-check success" v-if="result.isRight"></i>
                <i class="el-icon-close error" v-else></i>
              </template>
              <template v-else>
                <template v-if="result.answer">
                  <span class="success" v-if="result.isRight">{{result.answer}}</span>
                  <span class="error" v-else>{{result.answer}}</span>
                </template>
                <span class="error no-data" v-else>未作答</span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tooltip } from 'element-ui';
import VanSpeaker from 'vanthink-components/components/common/Speaker.vue';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    results: {
      type: Array,
      default() {
        return [];
      },
    },
    score: {
      type: Number,
      default: 0,
    },
  },
  components: {
    VanSpeaker,
    ElTooltip: Tooltip,
  },
  computed: {},
  methods: {},
  created() {

  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .exam-result {
    .exam-title {
      overflow: hidden;
      text-align: center;
      .title {
        margin-top: 60px;
      }
      .score {
        font-size: 100px;
        color: $primary;
        margin: 0 20px;
      }
      .tagline {
        color: #999;
      }
    }
    .table-wrap {
      height: 445px;
      .result-table {
        margin: 0 auto;
        width: 90%;
        height: 100%;
        text-align: center;
        font-size: 18px;
        box-shadow: 0 2px 6px 0 rgba(0,0,0,0.30);
        .table-head {
          width: 100%;
          div {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid $gray-bg-color;
          }
          div:first-child {
            width: 10%;
          }
          div:nth-child(2) {
            width: 20%;
          }
          div:nth-child(3) {
            width: 35%;
          }
          div:nth-child(4) {
            width: 15%;
          }
          div:last-child {
            width: 20%;
          }
        }
        .table-body {
          width: 100%;
          max-height: calc(100% - 41px);
          overflow-y: auto;
          .item {
            width: 100%;
            border-bottom: 1px solid $gray-bg-color;
            .no-data {
              font-size: 16px!important;
            }
            div {
              display: inline-block;
              width: 22.5%;
              height: 40px;
              line-height: 40px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
            div:first-child {
              width: 10%;
            }
            div:nth-child(2) {
              width: 20%;
            }
            div:nth-child(3) {
              width: 35%;
            }
            div:nth-child(4) {
              width: 15%;
            }
            div:last-child {
              width: 20%;
            }
            .text {
              position: relative;
              .text-wrap {
                margin: 0 auto;
                padding-left: 60px;
                width: 60%;
                text-align: left;
              }
            }
            .error {
              font-size: 18px;
              font-weight: 700;
              color: $danger;
            }
            .success {
              font-size: 18px;
              font-weight: 700;
              color: $success;
            }
          }
          .item:last-child {
            border-bottom: 0;
          }
        }
      }
    }
  }
</style>
